const iconData = require('./icons.json');
module.exports = { iconData: iconData };